// src/Dashboard/pages/teacher/Belts/components/BeltsBulkActionBar.jsx

import React from "react";
import { FaCheck, FaTimes } from "react-icons/fa";

export default function BeltsBulkActionBar({
  selectedCount,
  belts = [],
  bulkBeltId,
  setBulkBeltId,
  bulkDate,
  setBulkDate,
  saving,
  onApply,
  onClear,
}) {
  if (!selectedCount) return null;

  const sortedBelts = [...belts].sort((a, b) => Number(a.id || 0) - Number(b.id || 0));

  return (
    <div className="fixed inset-x-0 bottom-4 z-[60] px-3">
      <div className="mx-auto flex max-w-5xl flex-col gap-3 rounded-[24px] border border-slate-200 bg-white/95 p-3 shadow-2xl backdrop-blur dark:border-slate-700 dark:bg-slate-900/95 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <span className="inline-flex h-10 w-10 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
            {selectedCount}
          </span>

          <div>
            <p className="text-sm font-bold text-slate-900 dark:text-white">
              {selectedCount} adhérent{selectedCount > 1 ? "s" : ""} sélectionné
              {selectedCount > 1 ? "s" : ""}
            </p>

            <p className="text-xs text-slate-500 dark:text-slate-400">
              Choisissez la ceinture et la date à appliquer.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-2 sm:grid-cols-[220px_170px_auto_auto]">
          <select
            value={bulkBeltId}
            onChange={(event) => setBulkBeltId(event.target.value)}
            disabled={saving}
            className="rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 outline-none focus:ring-2 focus:ring-indigo-400 disabled:opacity-60 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200"
          >
            <option value="">Ceinture...</option>
            {sortedBelts.map((belt) => (
              <option key={belt.id} value={belt.id}>
                {belt.nom}
              </option>
            ))}
          </select>

          <input
            type="date"
            value={bulkDate}
            onChange={(event) => setBulkDate(event.target.value)}
            disabled={saving}
            className="rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 outline-none focus:ring-2 focus:ring-indigo-400 disabled:opacity-60 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200"
          />

          <button
            type="button"
            onClick={onApply}
            disabled={saving}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-[#013E8E] px-4 py-2 text-sm font-bold text-white transition hover:bg-[#012f6c] disabled:cursor-not-allowed disabled:opacity-60"
          >
            <FaCheck />
            {saving ? "Application..." : "Appliquer"}
          </button>

          <button
            type="button"
            onClick={onClear}
            disabled={saving}
            className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 transition hover:bg-slate-50 disabled:opacity-60 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200"
          >
            <FaTimes />
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
}